import React from 'react';

export default function UnCheckTrialIcon({isDiabled}) {
    if(isDiabled) {
        return <></>
    }
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="8" cy="8" r="7" fill="white" stroke="#C7CAD1" stroke-width="2" />
        </svg>
    );
}
